import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import classNames from 'classnames';

import CircularProgress from '@material-ui/core/CircularProgress';
import DeleteIcon from '@material-ui/icons/Delete';
import HelpIcon from '@material-ui/icons/HelpOutlined';

import FormattedPrice from '../../misc/FormattedPrice';

function CartItem(props) {
  return (
    <div className="cart-item-container">
      <div className="cart-item-content">
        {props.icon}
        <div
          className={classNames('cart-item-info-outer-container', {
            'has-icon': props.icon !== undefined,
          })}
        >
          <div className="cart-item-info-inner-container">
            <div className="cart-item-general-container">
              <div
                className={classNames('cart-item-title-container', {
                  'with-help-icon': props.hasHelpIcon,
                })}
                onClick={props.hasHelpIcon ? props.onHelpClick : null}
              >
                <p className="cart-item-title">{props.title}</p>
                {props.hasHelpIcon && <HelpIcon />}
              </div>
              {props.subtitle && (
                <div
                  className={classNames('cart-item-subtitle-container', {
                    'with-help-icon': props.subtitleHasHelpIcon,
                  })}
                  onClick={props.subtitleHasHelpIcon ? props.onSubtitleHelpClick: null}
                >
                  <p>{props.subtitle}</p>
                  {props.subtitleHasHelpIcon && <HelpIcon />}
                </div>
              )}
              <br />
              {props.eventName && <p>{props.eventName}</p>}
            </div>
            <div className="cart-item-price-container">
              <p className="cart-item-final-price">
                <FormattedPrice price={props.finalPrice} />
              </p>
              {props.discount && (
                <p className="cart-item-original-price">
                  <FormattedPrice price={props.originalPrice} />
                </p>
              )}
              {props.discount && <p className="cart-item-discount">-{props.discount}%</p>}
            </div>
          </div>
        </div>
      </div>
      <div className="cart-item-footer">
        {props.isDownloadOnly && (
          <div>
            <p className="cart-item-download-hint">
              <FormattedMessageWrappedInSpan
                id="cartItem.digitalDownloadOnlyHint"
                defaultMessage="Available as download only"
              />
            </p>
          </div>
        )}
        <div className="cart-item-footer-action-container">
          {props.isLoading && <CircularProgress size={15} thickness={4} />}
          {!props.isLoading && (
            <Fragment>
              {props.vat !== undefined && (
                <p className="cart-item-vat">
                  <FormattedMessageWrappedInSpan
                    id="cartItem.vat"
                    defaultMessage="VAT: {vat}%"
                    values={{ vat: props.vat }}
                  />
                </p>
              )}
              {props.hasAddToCartOption && (
                <p className="cart-item-add-option" onClick={props.onAddToCartClick}>
                  <FormattedMessageWrappedInSpan
                    id="cartItem.addToCartOption"
                    defaultMessage="Add to cart"
                  />
                </p>
              )}
              {props.hasDeleteOption && (
                <div
                  className="cart-item-delete-icon-container"
                  onClick={props.onDeleteClick}
                >
                  <DeleteIcon />
                </div>
              )}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
}

CartItem.defaultProps = {
  hasAddToCartOption: false,
  hasDeleteOption: true,
  hasHelpIcon: false,
  isDownloadOnly: false,
  isLoading: false,
  subtitleHasHelpIcon: false,
};

CartItem.propTypes = {
  discount: PropTypes.number,
  eventName: PropTypes.string,
  finalPrice: PropTypes.shape({
    amount: PropTypes.number,
    currency: PropTypes.string,
  }).isRequired,
  hasAddToCartOption: PropTypes.bool,
  hasDeleteOption: PropTypes.bool,
  hasHelpIcon: PropTypes.bool,
  icon: PropTypes.node,
  isDownloadOnly: PropTypes.bool,
  isLoading: PropTypes.bool,
  onAddToCartClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onHelpClick: PropTypes.func,
  onSubtitleHelpClick: PropTypes.func,
  originalPrice: PropTypes.shape({
    amount: PropTypes.number,
    currency: PropTypes.string,
  }),
  subtitle: PropTypes.node,
  subtitleHasHelpIcon: PropTypes.bool,
  title: PropTypes.node.isRequired,
  vat: PropTypes.number,
};

export default CartItem;
